/** @jsxImportSource theme-ui */
import { FormattedText } from "@bottlebooks/gatsby-design-system";
import { Trans } from "@lingui/macro";
import { FragmentType, graphql, useFragment } from "~/gql";
import Section from "../Section/Section";

const fragment = graphql(`
  fragment WineViticulture on Product {
    __typename
    ... on Wine {
      viticulture
    }
  }
`);

export default function WineViticulture({
  data,
  ...rest
}: {
  data: FragmentType<typeof fragment>;
}) {
  const product = useFragment(fragment, data);
  const wine = product.__typename === "Wine" ? product : null;
  if (!wine?.viticulture) return null;
  return (
    <Section title={<Trans>Viticulture</Trans>} {...rest}>
      <FormattedText text={wine.viticulture} variant="large" />
    </Section>
  );
}
